"use strict";
/// <reference types="./@types/basic" />
/// <reference types="./@types/custom" />
Object.defineProperty(exports, "__esModule", { value: true });
exports.E_FONT_SIZE_KEYS = exports.FONT_SIZE = exports.E_FONT_FAMILY = exports.E_BUTTON_TYPE = exports.hotelplanStyle = void 0;
var hotelplan_style_1 = require("./hotelplan-style");
Object.defineProperty(exports, "hotelplanStyle", { enumerable: true, get: function () { return hotelplan_style_1.hotelplanStyle; } });
var buttons_1 = require("./rich/buttons");
Object.defineProperty(exports, "E_BUTTON_TYPE", { enumerable: true, get: function () { return buttons_1.E_BUTTON_TYPE; } });
var font_faces_1 = require("./rich/font-faces");
Object.defineProperty(exports, "E_FONT_FAMILY", { enumerable: true, get: function () { return font_faces_1.E_FONT_FAMILY; } });
Object.defineProperty(exports, "FONT_SIZE", { enumerable: true, get: function () { return font_faces_1.FONT_SIZE; } });
Object.defineProperty(exports, "E_FONT_SIZE_KEYS", { enumerable: true, get: function () { return font_faces_1.E_FONT_SIZE_KEYS; } });
//# sourceMappingURL=index.js.map